<template>
  <div class>
    <div class="row">
      <div class="col-md-8 col-sm-8">
        <div class="card card-default widget animated">
          <div class="card-heading">
            <div class="row">
              <div class="col-md-5">
                <form-text label="Search Groups" name="searchgroups" v-model="searchQuery"></form-text>
              </div>
              <div
                class="col-md-2"
                v-if="org['curOrg']['role'] == '1' || org['curOrg']['role'] == '2' || org['curOrg']['role'] == 99"
              >
                <router-link to class="btn btn-success">Add</router-link>
              </div>
            </div>
            <br>
            <groups-table :data="groups" :columns="gridColumns" :filter-key="searchQuery"></groups-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GroupsTable from "./GroupsTable";
import FormText from "../../elements/Form/FormText";
import database from "../../webmaster/Database/database";
import store from "../../webmaster/Store/vuex";

export default {
  name: "inventory",
  components: {
    "groups-table": GroupsTable,
    "form-text": FormText
  },
  data() {
    return {
      org: store.state.usermain,
      groups: {},
      searchQuery: "",
      gridColumns: [
        "name",
        //"asset count",
        "more",
      ],
      gridColumns_export: {
        name: "String",
        //"asset count": "String",
        more: "String"
      }
    };
  },
  created:function() {
    this.fetchGroups();
  },
  methods: {
    fetchGroups: function(){
      this.groups = {"0LHSU9UmnqsPXzQ5vT5w":{"name":"Medicine",".key":"0LHSU9UmnqsPXzQ5vT5w"},"ALtxBrGX77YoICHKa1Yq":{"name":"Tools",".key":"ALtxBrGX77YoICHKa1Yq"},"KKqkAOzzxvgbk49ljtmh":{"name":"Entertainment",".key":"KKqkAOzzxvgbk49ljtmh"},"WfK3QL2TVz5qImDX3eR2":{"name":"Book",".key":"WfK3QL2TVz5qImDX3eR2"},"oyDvLSAce4mAgA2g5vYr":{"name":"Pain Reliever",".key":"oyDvLSAce4mAgA2g5vYr"},"spV4liYK2Ib6n1MI5KUZ":{"name":"Bedding",".key":"spV4liYK2Ib6n1MI5KUZ"}};
      /*let orgId = this.$store.state.usermain.curOrg.id;

      let self = this;

      console.log('orgs/' + orgId + '/groups/');

      let collection = database.getFireStoreColl('orgs/' + orgId + '/groups/');

      collection.get().then(function(querySnapshot) {
        let _groups = {}

        console.log(querySnapshot.documents);

        querySnapshot.forEach(doc => {
          console.log("--------")
          console.log(doc.data())
          console.log("--------")
          
          _groups[doc.id] = doc.data()
          _groups[doc.id]['.key'] = doc.id;
        });

        self.groups = _groups;
      });

      console.log("Imma done"); */

    },
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>


// WEBPACK FOOTER //
// Groups.vue?664dcf32